import React from 'react';
import './Contact.css';
import useReveal from '../hooks/useReveal';
import { schoolInfo } from '../data/schoolData';
import imgGate from '../assets/images/schoolgate.jpeg';

const rows = [
  { icon: '📍', label: 'Address',        value: `${schoolInfo.address}, Tq: ${schoolInfo.taluk}, Dist: ${schoolInfo.district}, ${schoolInfo.state}` },
  { icon: '✉️', label: 'Email',          value: schoolInfo.email },
  { icon: '🏫', label: 'DISE Code',      value: schoolInfo.dise },
  { icon: '📚', label: 'Classes',        value: schoolInfo.classes },
  { icon: '🗣️', label: 'Medium',         value: schoolInfo.medium },
  { icon: '✝️', label: 'Administration', value: schoolInfo.administration },
  { icon: '👤', label: 'Principal',      value: 'Fr. Francis Buddini' },
];

export default function Contact() {
  const r1 = useReveal(), r2 = useReveal();
  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <div className="section-head center reveal">
          <span className="stag">Get In Touch</span>
          <h2 className="stitle">Contact & Location</h2>
          <div className="sline center" />
        </div>
        <div className="contact-grid">
          <div className="contact-card reveal" ref={r1}>
            <h3>School Information</h3>
            {rows.map(r => (
              <div key={r.label} className="crow">
                <div className="cico">{r.icon}</div>
                <div>
                  <strong>{r.label}</strong>
                  <span>{r.value}</span>
                </div>
              </div>
            ))}
            <div style={{ marginTop: 24, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a href={schoolInfo.mapsUrl} target="_blank" rel="noreferrer" className="btn-primary">
                📍 Open in Google Maps
              </a>
              <a
                href={`https://wa.me/91${schoolInfo.whatsapp}?text=${encodeURIComponent('Hello! I would like to inquire about admissions at St. Xavier\'s School.')}`}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
              >
                💬 Chat on WhatsApp
              </a>
            </div>
          </div>
          <div className="map-card reveal" ref={r2}>
            <div className="map-img"><img src={imgGate} alt="School Gate" /></div>
            <div className="map-info">
              <h4>{schoolInfo.name}</h4>
              <p>{schoolInfo.address}<br />{schoolInfo.taluk} | {schoolInfo.district}, {schoolInfo.state}</p>
              <a href={schoolInfo.mapsUrl} target="_blank" rel="noreferrer" className="map-btn">
                🗺️ View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
